var map = {
	"./1.jpg": 665,
	"./2.jpg": 9902,
	"./3.jpg": 7947,
	"./4.jpg": 8152,
	"./5.jpg": 6021,
	"./6.jpg": 6122,
	"./7.jpg": 1959,
	"./8.jpg": 2900,
	"./9.jpg": 7233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5613;